var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"blockchain-list"},_vm._l((_vm.blockchainNetworks),function(blockchainNetwork){return _c('BlockchainNetworksItem',{key:blockchainNetwork.id,attrs:{"blockchainNetwork":blockchainNetwork}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }